/* eslint-disable no-inner-declarations */
import "suneditor/dist/css/suneditor.min.css";

import {
  Card,
  Checkbox,
  DialogActions,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Icon,
  InputAdornment,
  MenuItem,
  Typography,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CardContent from "@material-ui/core/CardContent";
import Fab from "@material-ui/core/Fab";
import { withStyles } from "@material-ui/core/styles";
import Switch from "@material-ui/core/Switch";
import Tooltip from "@material-ui/core/Tooltip";
import Add from "@material-ui/icons/Add";
import Search from "@material-ui/icons/Search";
import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  SelectValidator,
  TextValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import MaterialUiIconPicker from "react-material-ui-icon-picker";
import { connect } from "react-redux";
import SunEditor from "suneditor-react";

import Dialog from "../../components/Dialog";
import TableData from "../../components/TableData";
import datetimeHelper from "../../helper/datetime-helper";
import { globalHistory } from "../../history";
import { mapActionsToProps } from "../../redux/miniCrm/article";
import { mapActionsToProps as topicAction } from "../../redux/miniCrm/topic";

const styles = (theme) => ({
  model: {
    width: "100%",
  },
  card: {
    maxWidth: "100%",
  },
  form: {
    width: "100%",
  },
  input: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  chip: {
    margin: theme.spacing.unit,
  },
  fab: {
    margin: theme.spacing.unit * 3,
    whiteSpace: "nowrap",
  },
  grid: {
    display: "flex",
    alignItems: "center",
  },
});

class Article extends Component {
  constructor(props) {
    super(props);
    this.state = {
      length: 0,
      data: [],
      modalSend: false,
      filters: {
        order: "createdAt DESC",
        where: {
          gte: null,
          lte: null,
        },
        page: 0,
        pageSize: 20,
      },
      item: null,
      modalAction: false,
      modalDelete: false,
      isPublished: false,
      isNew: false,
      itemCreate: {},
    };
    this.editor = React.createRef();
  }
  async componentDidMount() {
    await this.itemInit();
    this.history = globalHistory();
  }

  listCollumns = [
    { id: "title", numeric: true, disablePadding: false, label: "Tiêu đề" },
    { id: "icon", numeric: true, disablePadding: false, label: "Icon" },
    {
      id: "isPublished",
      numeric: true,
      disablePadding: false,
      label: "Xuất bản",
    },
    {
      id: "isNew",
      numeric: true,
      disablePadding: false,
      label: "Bài viết mới",
    },
    { id: "tags", numeric: true, disablePadding: false, label: "Tags" },
    // { id: "description", numeric: true, disablePadding: false, label: "Miêu tả" },
    {
      id: "createdAt",
      numeric: true,
      disablePadding: false,
      label: "Ngày tạo",
    },
    { id: "action", numeric: true, disablePadding: false, label: "Hành động" },
  ];

  itemInit() {
    const where = {};
    const and = [];
    const { filters } = this.state;
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            case "title":
            case "tags":
            case "topicId":
            default: {
              if (
                (key.startsWith("from") || key.startsWith("to")) &&
                key !== "topicId"
              ) {
                if (key == "from") {
                  and.push({ time: { gte: this.state.filters.where.from } });
                  where.and = and;
                } else {
                  and.push({ time: { lte: this.state.filters.where.to } });
                  where.and = and;
                }
              } else {
                where[key] = element;
              }
              break;
            }
          }
        }
      }
    }
    this.props.countListArticle({ where: where });
    this.props.getListArticle(filters.order, filters.pageSize, filters.page, {
      where,
    });
    this.props.getListTopic();
  }

  openDialogCreate = () => {
    this.setState({ modalSend: !this.state.modalSend });
  };

  handleClose = () => {
    this.setState({ modalSend: false, modalAction: false, modalDelete: false });
  };

  openModalEdit = (item) => {
    this.state.item = item;
    this.setState({ modalAction: true });
  };

  openModalDelete = (item) => {
    this.state.item = item;
    this.setState({ modalDelete: true });
  };

  handleChangePage = (e, page) => {
    const { filters } = this.state;
    this.setState({ page });
    filters.page = page * filters.pageSize;
    this.itemInit();
  };

  handleChangeRowsPerPage = (e) => {
    const { filters } = this.state;
    filters.pageSize = e.target.value;
    this.setState(
      {
        filters,
      },
      () => {
        this.itemInit();
      }
    );
  };

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    filters.where[name] = name === "title" && value ? { like: value } : value;
    this.setState({
      filters,
    });
  };
  handleSubmit = (e) => {
    const { filters } = this.state;
    filters.skip = 0;
    this.setState(
      {
        disable: false,
        filters: {
          ...filters,
          page: 0,
        },
      },
      () => {
        setTimeout(() => {
          this.itemInit();
        }, 1000);
      }
    );
  };

  handleDateChangeStart = (from) => {
    const { filters } = this.state;
    filters.where.from = datetimeHelper.toFormat(from, "YYYY-MM-DD");
    this.setState({ from });
  };

  handleDateChangeEnd = (to) => {
    const { filters } = this.state;
    filters.where.to = datetimeHelper.toFormat(to, "YYYY-MM-DD");
    this.setState({ to });
  };

  handleChangeText = (name) => {
    return (e) => {
      this.setState({
        itemCreate: {
          ...this.state.itemCreate,
          [name]: e.target.value,
        },
      });
    };
  };

  handleChangeTextEdit = (name) => {
    return (e) => {
      this.setState({
        item: {
          ...this.state.item,
          [name]: e.target.value ? e.target.value : e.target.checked,
        },
      });
    };
  };

  handleChangeCheckText = (name) => {
    return (e) => {
      this.setState({
        [name]: e.target.checked,
        itemCreate: {
          ...this.state.itemCreate,
          [name]: e.target.checked,
        },
      });
    };
  };

  handleChangeTextCheckEdit = (name) => {
    return (e) => {
      this.setState({
        [name]: e.target.checked,
        item: {
          ...this.state.item,
          [name]: e.target.checked,
        },
      });
    };
  };

  handleCreateModel = () => {
    this.setState({ modalAction: true, item: {}, itemCreate: {} });
  };

  handleAction = () => {
    const { id } = this.state.item;
    let data = [];
    if (!id) {
      const {
        title,
        icon,
        description,
        content,
        tags,
        topicId,
        isPublished,
        isNew,
      } = this.state.itemCreate;
      const newItem = tags.split(",");
      newItem.forEach((element) => {
        data.push(element);
      });
      return (
        this.props.addNewArticle(
          title,
          icon,
          description,
          content,
          { tags: data },
          topicId,
          isPublished,
          isNew
        ),
        setTimeout(
          function () {
            this.setState({ modalAction: false });
            this.itemInit();
          }.bind(this),
          500
        )
      );
    } else {
      const {
        id,
        title,
        icon,
        description,
        content,
        tags,
        topicId,
        isPublished,
        isNew,
      } = this.state.item;
      const newItem = tags.toString().split(",");
      newItem.forEach((element) => {
        data.push(element);
      });
      return (
        this.props.editArticle(
          id,
          title,
          icon,
          description,
          content,
          { tags: data },
          topicId,
          isPublished,
          isNew
        ),
        setTimeout(
          function () {
            this.setState({ modalAction: false });
            this.itemInit();
          }.bind(this),
          500
        )
      );
    }
  };

  handleDelete = () => {
    this.props.deleteArticle(this.state.item.id);
    setTimeout(
      function () {
        this.setState({ modalDelete: false });
        this.itemInit();
      }.bind(this),
      500
    );
  };

  showPickedIcon = (ico) => {
    this.setState({
      itemCreate: {
        ...this.state.itemCreate,
        icon: ico.name,
      },
    });
  };

  showPickedIconEdit = (ico) => {
    this.setState({
      item: {
        ...this.state.item,
        icon: ico.name,
      },
    });
  };

  onEditorChange(content) {
    this.setState({
      content: content,
    });
  }

  onEditorChangeEdit(content) {
    this.setState({
      item: {
        ...this.state.item,
        content: content,
      },
    });
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (!!nextState.item && !!this.state.item) {
      if (this.state.item.content !== nextState.item.content) {
        return false;
      } else {
        return true;
      }
    } else {
      if (this.state.content !== nextState.content) {
        return false;
      } else {
        return true;
      }
    }
  }

  onHandleKeyPress = (e) => {
    if (e.key === "Enter") {
      this.handleSubmit();
    }
  };

  render() {
    const { classes, listArticle, coutArticle, listTopic } = this.props;
    const {
      title,
      icon,
      description,
      content,
      tags,
      topicId,
      isPublished,
      filters,
      item,
      modalDelete,
      isNew,
      itemCreate,
    } = this.state;
    let listTopicFormat = [];

    if (listTopic) {
      listTopic.forEach((topic) => {
        const tempTopic = JSON.parse(JSON.stringify(topic));
        delete tempTopic.children;
        listTopicFormat.push(tempTopic);
        formatListTopic(topic);
      });

      function formatListTopic(topic) {
        if (topic.children !== undefined) {
          if (topic.children.length) {
            topic.children.forEach((item) => {
              const tempItem = JSON.parse(JSON.stringify(item));
              delete tempItem.children;
              listTopicFormat.push(item);
              return formatListTopic(item);
            });
          }
        }
      }
    }
    return (
      <React.Fragment>
        <ValidatorForm
          ref="form"
          onSubmit={this.handleSubmit}
          onError={(errors) => console.log(errors)}
          className={classes.form}>
          <Card className={classes.card}>
            <CardContent>
              <FormControl className={classes.form}>
                <FormGroup className={classes.form}>
                  <Grid container spacing={24}>
                    <Grid item md={3}>
                      <TextValidator
                        id="outlined-full-width"
                        margin="normal"
                        label="Tên tiêu đề"
                        variant="outlined"
                        className={classes.input}
                        onChange={this.handleSearch}
                        value={
                          filters.where.title ? filters.where.title.like : ""
                        }
                        name="title"
                        onKeyPress={(e) => this.onHandleKeyPress(e)}
                      />
                    </Grid>
                    <Grid item md={3}>
                      <TextValidator
                        id="outlined-full-width"
                        margin="normal"
                        label="Tags"
                        variant="outlined"
                        className={classes.input}
                        onChange={this.handleSearch}
                        value={filters.where.tags ? filters.where.tags : ""}
                        name="tags"
                        onKeyPress={(e) => this.onHandleKeyPress(e)}
                      />
                    </Grid>
                    <Grid item md={3}>
                      <SelectValidator
                        id="outlined-full-width"
                        margin="normal"
                        select
                        SelectProps={{
                          MenuProps: {
                            className: classes.menu,
                            shrink: true,
                          },
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label="Chủ đề"
                        variant="outlined"
                        className={classes.input}
                        onChange={this.handleSearch}
                        value={filters.where.topicId}
                        name="topicId"
                        validators={["required"]}
                        errorMessages={"Không được để trống"}>
                        <MenuItem>
                          <em>Tất cả</em>
                        </MenuItem>
                        {listTopicFormat
                          ? listTopicFormat.map((item) => {
                              return (
                                <MenuItem key={item.id} value={item.id}>
                                  {item.title}
                                </MenuItem>
                              );
                            })
                          : null}
                      </SelectValidator>
                    </Grid>
                    <Grid item md={3}>
                      <Tooltip title="Tìm kiếm" disableFocusListener>
                        <Fab
                          color="primary"
                          aria-label="Search"
                          className={classes.fab}
                          onClick={this.handleSubmit}>
                          <Search />
                        </Fab>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </FormGroup>
              </FormControl>
            </CardContent>
          </Card>
        </ValidatorForm>
        <TableData
          {...this.props}
          nameTable="Danh sách"
          items={listArticle}
          rowsPerPage={filters.pageSize}
          count={coutArticle?.count ?? 0}
          page={
            filters.pageSize === 20
              ? filters.page / 20
              : filters.pageSize === 40
              ? filters.page / 40
              : filters.pageSize === 60
              ? filters.page / 60
              : filters.pageSize === 80
              ? filters.page / 80
              : filters.page / 100
          }
          rowItems={this.listCollumns}
          allowCreate={true}
          handleEdit={this.openModalEdit}
          handleDelete={this.openModalDelete}
          handleChangePage={this.handleChangePage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          createAction={
            <Tooltip title="Thêm mới" disableFocusListener>
              <Fab
                color="primary"
                aria-label="add"
                className={classes.fab}
                size="small"
                onClick={this.handleCreateModel}>
                <Add className={classes.add} />
              </Fab>
            </Tooltip>
          }
        />
        <Dialog
          open={modalDelete}
          title={`Bạn có muốn xóa?`}
          button={true}
          onSubmit={this.handleDelete}
          onClose={this.handleClose}
        />
        <Dialog
          open={this.state.modalAction}
          fullwidth={true}
          title={
            item ? (item.id ? "Chỉnh sửa thông tin" : "Thêm thông tin") : null
          }
          maxWidth={"xl"}
          input={
            <ValidatorForm
              ref="form"
              onSubmit={this.handleAction}
              onError={(errors) => console.log(errors)}
              className={classes.form}>
              <FormControl className={classes.form}>
                <Grid container className={classes.grid}>
                  <SelectValidator
                    id="outlined-full-width"
                    margin="normal"
                    select
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu,
                        shrink: true,
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Chủ đề"
                    autoFocus={true}
                    variant="outlined"
                    className={classes.input}
                    onChange={
                      item
                        ? item.id
                          ? this.handleChangeTextEdit("topicId")
                          : this.handleChangeText("topicId")
                        : null
                    }
                    value={
                      item
                        ? item.id
                          ? item.topicId
                          : itemCreate.topicId
                        : null
                    }
                    name="topicId"
                    validators={["required"]}
                    errorMessages={"Không được để trống"}>
                    {listTopicFormat
                      ? listTopicFormat.map((item) => {
                          return (
                            <MenuItem key={item.id} value={item.id}>
                              {item.title}
                            </MenuItem>
                          );
                        })
                      : null}
                  </SelectValidator>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={
                          item
                            ? item.id
                              ? item.isNew === true
                              : itemCreate.isNew
                            : null
                        }
                        onChange={
                          item
                            ? item.id
                              ? this.handleChangeTextCheckEdit("isNew")
                              : this.handleChangeCheckText("isNew")
                            : null
                        }
                        value="isNew"
                      />
                    }
                    label="Bài viết mới"
                  />
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Tên tiêu đề"
                    variant="outlined"
                    className={classes.input}
                    onChange={
                      item
                        ? item.id
                          ? this.handleChangeTextEdit("title")
                          : this.handleChangeText("title")
                        : null
                    }
                    value={
                      item ? (item.id ? item.title : itemCreate.title) : null
                    }
                    name="title"
                    validators={["required"]}
                    errorMessages="Không được để trống"
                  />
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Tags"
                    variant="outlined"
                    className={classes.input}
                    onChange={
                      item
                        ? item.id
                          ? this.handleChangeTextEdit("tags")
                          : this.handleChangeText("tags")
                        : null
                    }
                    value={
                      item ? (item.id ? item.tags : itemCreate.tags) : null
                    }
                    name="tags"
                    validators={["required"]}
                    errorMessages="Không được để trống"
                  />
                  <Grid container className={classes.grid}>
                    <Grid item lg={8}>
                      <TextValidator
                        id="outlined-full-width"
                        margin="normal"
                        placeholder="Icon"
                        variant="outlined"
                        className={classes.input}
                        // onChange={!!item ? (item.id ? this.handleChangeTextEdit('icon') : this.handleChangeText('icon')) : null}
                        value={
                          item ? (item.id ? item.icon : itemCreate.icon) : ""
                        }
                        disabled
                        name="icon"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Icon>
                                {item
                                  ? item.id
                                    ? item.icon
                                    : itemCreate.icon
                                  : ""}
                              </Icon>
                            </InputAdornment>
                          ),
                        }}
                        // validators={["required"]}
                        // errorMessages="Không được để trống"
                        // helperText="Icon theo chuẩn Material UI - https://material.io/tools/icons/?style=baseline"
                      />
                    </Grid>
                    <Grid item lg={1}></Grid>
                    <Grid item lg={3}>
                      <MaterialUiIconPicker
                        onPick={
                          item
                            ? item.id
                              ? this.showPickedIconEdit
                              : this.showPickedIcon
                            : null
                        }
                        label="Chọn Icon"
                        pickLabel="Done"
                      />
                    </Grid>
                  </Grid>
                  {/*<TextValidator*/}
                  {/*    id="outlined-full-width"*/}
                  {/*    margin="normal"*/}
                  {/*    label="Miêu tả"*/}
                  {/*    variant="outlined"*/}
                  {/*    className={classes.input}*/}
                  {/*    onChange={!!item ? (item.id ? this.handleChangeTextEdit('description') : this.handleChangeText('description')) : null}*/}
                  {/*    value={!!item ? (item.id ? item.description : description) : null}*/}
                  {/*    name="description"*/}
                  {/*/>*/}
                  <Typography
                    component="p"
                    style={{ marginTop: 10, marginBottom: 10, width: "100%" }}>
                    Nội dung
                  </Typography>
                  <SunEditor
                    showToolbar={true}
                    enableToolbar={true}
                    // show={true}
                    enable={true}
                    setOptions={{
                      font: [
                        "Arial",
                        "Tohoma",
                        "Calibri",
                        "Courier New,Courier",
                        "Comic Sans MS",
                        "Times New Roman",
                        "Microsoft Sans Serif",
                      ],
                      buttonList: [
                        ["undo", "redo", "font", "fontSize", "formatBlock"],
                        [
                          "bold",
                          "underline",
                          "italic",
                          "strike",
                          "subscript",
                          "superscript",
                          "removeFormat",
                        ],
                        ["fontColor", "hiliteColor"],
                        [
                          "outdent",
                          "indent",
                          "align",
                          "horizontalRule",
                          "list",
                        ],
                        [
                          "link",
                          "table",
                          "image",
                          "video",
                          "fullScreen",
                          "showBlocks",
                          "codeView",
                          "preview",
                          "print",
                        ],
                      ],
                    }}
                    onChange={
                      item !== null && item.id !== undefined
                        ? (content) =>
                            this.setState({
                              item: {
                                ...this.state.item,
                                content: content,
                              },
                            })
                        : (content) =>
                            this.setState({
                              itemCreate: {
                                ...this.state.itemCreate,
                                content: content,
                              },
                            })
                    }
                    setContents={
                      item !== null && item.id !== undefined
                        ? item.content
                        : itemCreate.content
                    }
                  />
                  {/* <JoditEditor
                                        ref={this.editor}
                                        value={(item !== null && item.id !== undefined) ? item.content : content}
                                        config={{
                                            readonly: false
                                        }}
                                        tabIndex={1}
                                        onChange={(item !== null && item.id !== undefined) ? content =>
                                            this.setState({
                                                item: {
                                                    ...this.state.item,
                                                    content: content
                                                }
                                            }) : content => this.setState({
                                                content: content
                                            })}
                                    /> */}
                  <FormControlLabel
                    control={
                      <Switch
                        checked={
                          item
                            ? item.id
                              ? item.isPublished
                              : itemCreate.isPublished
                            : null
                        }
                        onChange={
                          item
                            ? item.id
                              ? this.handleChangeTextCheckEdit("isPublished")
                              : this.handleChangeCheckText("isPublished")
                            : null
                        }
                        value="isPublished"
                      />
                    }
                    style={{ width: "100%" }}
                    label="Xuất bản"
                  />
                </Grid>
                <DialogActions>
                  <Button
                    onClick={this.handleClose}
                    color="secondary"
                    className={classes.button}>
                    Hủy
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className={classes.button}>
                    Lưu
                  </Button>
                </DialogActions>
              </FormControl>
            </ValidatorForm>
          }
          onClose={this.handleClose}
        />
        {/*<Dialog*/}
        {/*  open={this.props.loading}*/}
        {/*  title={<CircularProgress/>}*/}
        {/*/>*/}
      </React.Fragment>
    );
  }
}

Article.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  listArticle: state.article.articles,
  coutArticle: state.article.count,
  listTopic: state.topic.listTopic,
  loading: state.article.loading,
});

const Topic = connect(mapStateToProps, topicAction)(Article);
Article = connect(null, mapActionsToProps)(Topic);

export default withStyles(styles)(Article);
